import React, { useEffect, useState } from "react";
import styles from "../onboard.module.css";
import { Row, Card, Col, Button, Spinner, Modal } from "react-bootstrap";
import { onBoardPersonalDetail } from "../../../api";
import { useMyContext } from "../../../myContext";
import addicon from "../../signup/assets/addFundsGrey.svg";
import VisitedBeneficiary from "./visitedBeneficiary";
import greentickmark from "../../signup/assets/greenTickIcon.svg";
import "react-international-phone/style.css";
import { PhoneNumberUtil } from "google-libphonenumber";
// import { CountryMapping } from "../../../utils";
import Beneficiaryform from "./beneficiaryform";
import cross from "../../../public/assets/closeIcon.svg";
import { defaultBoderlessCountryName } from "../../../constant";

const AddressDetail = ({
  isBeneficiaryFoamFlow,
  stepToShow,
  setStepsToShow,
  beneficiaryList,
  shortDetail,
  setShortDetail,
  beneficiaryLoader,
  showBeneficiaryDetail,
  setShowBeneficiaryDetail,
  setShowBeneficiaryBankDetail,
  setBeneficiaryBankCardSelection,
  beneficiaryCardSelection,
  setBeneficiaryCardSelection,
  addnewButton,
  fetchCardDetail,
}) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [loading, setLoading] = useState("");
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneNoError, setPhoneNoError] = useState("");
  const [postalError, setPostalError] = useState("");
  const [nextSectionError, setNextSectionError] = useState("");
  const [indianCountryCode, setIndianCountryCode] = useState(false);
  const [fixedCountry, setFixedCountry] = useState("");
  const [showModal, setShowModal] = useState(false);
  // const [referenceNumber, setReferenceNumber] = useState("");
  const [valid, setIsValid] = useState({
    name: false,
    email: false,
    phoneNumber: false,
    postalCode: false,
    address: false,
    city: false,
    state: false,
    country: false,
  });
  const {
    setBeneficicaryUserId,
    beneficiarySecondFlow,
    setBeneficiarySecondFlow,
    setBeneficiaryBankSecondFlow,
    setSelectedBeneficiaryBank,
    setCompletedBeneficiary,
    countryObject,
    setCountryObject,
    themeColor,
    CountryMapping,
  } = useMyContext();

  const phoneUtil = PhoneNumberUtil.getInstance();
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const subPurpose = sessionStorage.getItem("subPurpose");

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (!showBeneficiaryDetail) {
      if (subPurpose === "GIC (Canada)") {
        setFixedCountry("CANADA");
        handleChangeOptionforCountry("CANADA");
        const findCountry = CountryMapping.find(
          (item) => item.borderLessCountryName.toLowerCase() === "canada"
        );
        if (findCountry) {
          setCountryObject(findCountry);
          sessionStorage.setItem("country", JSON.stringify(findCountry));
        }
      } else if (subPurpose === "Blocked Account (Others)") {
        setFixedCountry("GERMANY");
        handleChangeOptionforCountry("GERMANY");
        const findCountry = CountryMapping.find(
          (item) => item.borderLessCountryName.toLowerCase() === "germany"
        );
        if (findCountry) {
          setCountryObject(findCountry);
          sessionStorage.setItem("country", JSON.stringify(findCountry));
        }
      } else {
        handleChangeOptionforCountry();
        const findCountry = CountryMapping.find(
          (item) => item.borderLessCountryName === defaultBoderlessCountryName
        );

        setCountryObject(findCountry);
        let countryObjectInString = JSON.stringify(findCountry);
        sessionStorage.setItem("country", countryObjectInString);
      }
    }
  }, []);

  const isPhoneValid = (phone) => {
    try {
      return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
    } catch (error) {
      return false;
    }
  };

  let countryOptions = [];

  CountryMapping.map((key) => {
    countryOptions.push({
      label: key.name,
      value: key.borderLessCountryName,
    });
  });

  const handleChangeOptionforCountry = (
    value = defaultBoderlessCountryName
  ) => {
    setCountry(defaultBoderlessCountryName === value ? "USA" : value);
    const selectedcountry = CountryMapping.find(
      (item) => item.borderLessCountryName === value
    );
    let countryObjectinString = JSON.stringify(selectedcountry);
    sessionStorage.setItem("country", countryObjectinString);
    setCountryObject(selectedcountry);
    setCountryCode(selectedcountry?.countryCode);
  };

  const ValidateEmail = (e) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(email)) {
      setEmailError("");
      return false;
    } else {
      return true;
    }
  };

  const handleBlur = (e) => {
    if (e.target.name === "name") {
      if (name !== "" && name.length < 4) {
        setIsValid({ ...valid, name: true });
        setNameError("Name should be 4 charcter or more.");
      } else {
        setIsValid({ ...valid, name: false });
        setNameError("");
      }
    } else if (e.target.name === "email") {
      if (ValidateEmail() && email !== "") {
        setIsValid({ ...valid, email: true });
        setEmailError("Enter a valid email such as example@email.com");
      } else {
        setEmailError("");
        setIsValid({ ...valid, email: false });
      }
    } else if (e.target.name === "phoneNumber") {
      if (
        phoneNumber !== "" &&
        !isPhoneValid(
          indianCountryCode === true
            ? "+91" + phoneNumber
            : subPurpose === "GIC"
            ? "+1" + phoneNumber
            : subPurpose === "Blocked Account"
            ? "+49" + phoneNumber
            : countryCode + phoneNumber
        )
      ) {
        setIsValid({ ...valid, phoneNumber: true });
        setPhoneNoError("Invalid Phone Number.");
      } else {
        setIsValid({ ...valid, phoneNumber: false });
        setPhoneNoError("");
      }
    } else if (e.target.name === "Postal") {
      if (postalCode !== "" && postalCode.length < 4) {
        setIsValid({ ...valid, postalCode: true });
        setPostalError("Postal Code should be atleast 4 digit long.");
      } else {
        setIsValid({ ...valid, postalCode: false });
        setPostalError("");
      }
    }
  };

  const handleChange = (e) => {
    if (e.target.name == "name") {
      setName(e.target.value);
    } else if (e.target.name == "email") {
      setEmail(e.target.value);
    } else if (e.target.name == "phoneNumber") {
      setPhoneNumber(e.target.value);
    } else if (e.target.name == "Postal") {
      if (e.target.value === "" || e.target.value.length <= 7) {
        setPostalCode(e.target.value);
      }
    } else if (e.target.name == "Address") {
      setAddress(e.target.value);
    } else if (e.target.name == "City") {
      setCity(e.target.value);
    } else if (e.target.name == "State") {
      setState(e.target.value);
    } else if (e.target.name == "Country") {
      setCountry(e.target.value);
    }
    // else if (e.target.name == "reference number") {
    //   if (e.target.value.length <= 80) {
    //     setReferenceNumber(e.target.value);
    //   }
    // }
  };

  const checkIfValid = () => {
    if (name === "") {
      setIsValid({ ...valid, name: true });
    } else if (email === "") {
      setIsValid({ ...valid, email: true });
    } else if (phoneNumber === "") {
      setIsValid({ ...valid, phoneNumber: true });
    } else if (postalCode === "") {
      setIsValid({ ...valid, postalCode: true });
    } else if (address === "") {
      setIsValid({ ...valid, address: true });
    } else if (city === "") {
      setIsValid({ ...valid, city: true });
    } else if (state === "") {
      setIsValid({ ...valid, state: true });
    } else if (country === "") {
      setIsValid({ ...valid, country: true });
    } else if (
      nameError !== "" ||
      emailError !== "" ||
      phoneNoError !== "" ||
      postalError !== ""
    ) {
      setNextSectionError("Please fill all the required field correctly.");
    } else {
      setIsValid({
        name: false,
        email: false,
        phoneNumber: false,
        postalCode: false,
        address: false,
        city: false,
        state: false,
        country: false,
      });
      setNextSectionError("");
      beneficiaryPersonalDetailApi();
    }
  };

  const beneficiaryPersonalDetailApi = () => {
    setLoading(true);
    const beneficiaryPersonalDetailData = async () => {
      const body = {
        name: name,
        address: address,
        city: city,
        state: state,
        country:
          fixedCountry !== "" ? country : countryObject.borderLessCountryName,
        postalCode: postalCode,
        email: email,
        phone:
          indianCountryCode === true
            ? "+91" + phoneNumber
            : subPurpose === "GIC"
            ? "+1" + phoneNumber
            : subPurpose === "Blocked Account"
            ? "+49" + phoneNumber
            : countryCode + phoneNumber,
        accountType: "Beneficiary",
        firstName: name,
        // referenceNumber: referenceNumber,
      };
      try {
        onBoardPersonalDetail(body).then((resp) => {
          console.log(
            "🐛 DEBUG: ~ file: addressDetail.js:306 ~ onBoardPersonalDetail ~ resp",
            resp
          );
          setLoading(false);
          if (resp.status === 200 && resp.data && resp.data.data) {
            setBeneficicaryUserId(resp.data.data.userAccountId);
            setBeneficiaryCardSelection(false);
            setBeneficiaryBankCardSelection(true);
            setShowBeneficiaryDetail(true);
            setBeneficiarySecondFlow(true);
            setStepsToShow("BeneficiaryStep2");
            setShowModal(false);
            setShortDetail({
              name: name,
              phone: phoneNumber,
              email: email,
              address: address,
              city: city,
              state: state,
              postalcode: postalCode,
              country: country,
            });
            setName("");
            setEmail("");
            setPhoneNumber("");
            setPostalCode("");
            setAddress("");
            setCity("");
            setState("");
            setCountry("");
          } else {
            setNextSectionError(
              resp && resp.data
                ? resp.data.message
                : "something went wrong, please try again later."
            );
          }
        });
      } catch (error) {
        setLoading(false);
        setNextSectionError("something went wrong, please try again later.");
      }
    };
    beneficiaryPersonalDetailData();
  };

  const handleChangeNew = (e) => {
    e.preventDefault();
    setBeneficiaryCardSelection(false);
    setStepsToShow("BeneficiaryStep1");
    setShowModal(true);
  };

  const handleChangeBack = (e) => {
    e.preventDefault();
    fetchCardDetail();
    setShowBeneficiaryDetail(false);
    setStepsToShow("");
    setBeneficiaryBankSecondFlow(false);
    setBeneficiaryBankCardSelection(false);
    setSelectedBeneficiaryBank(null);
    setShowBeneficiaryBankDetail(false);
    setCompletedBeneficiary(false);
    setShowModal(false);
  };

  const handleCountryCheck = () => {
    setPhoneNumber("");
    setIndianCountryCode(!indianCountryCode);
    setIsValid({ ...valid, phoneNumber: false });
    setPhoneNoError("");
  };

  return (
    <Card className={styles.cardAccount}>
      <Card.Body className={styles.cardBodyAccount}>
        <div className={styles.headingandbutton}>
          <Row className={styles.Title}>Personal Detail</Row>
          {beneficiarySecondFlow === true &&
            beneficiaryLoader === false &&
            !isBeneficiaryFoamFlow && (
              <>
                {beneficiaryCardSelection === true ? (
                  <div
                    className={styles.buttonaddnew}
                    onClick={handleChangeNew}
                  >
                    <img src={addicon} alt=""></img>
                    Add new
                  </div>
                ) : (
                  <>
                    <div
                      className={
                        showBeneficiaryDetail === false
                          ? styles.buttonback
                          : styles.buttonEdit
                      }
                      onClick={handleChangeBack}
                    >
                      {showBeneficiaryDetail === true
                        ? "Edit"
                        : stepToShow === "BeneficiaryStep1"
                        ? "Back"
                        : ""}
                    </div>
                  </>
                )}
              </>
            )}
        </div>
        {beneficiaryLoader ? (
          <Spinner
            animation="border"
            className={styles.spinnerColorOutside}
            style={{ borderColor: themeColor, borderRightColor: "#eaecf0" }}
          />
        ) : (
          <>
            {showBeneficiaryDetail === true ? (
              <>
                <Row>
                  <Col md={11} sm={11} xs={10} className={styles.details}>
                    {shortDetail.name}, {shortDetail.phone}, {shortDetail.email}
                    , {shortDetail.address}, {shortDetail.city},{" "}
                    {shortDetail.state}, {shortDetail.postalcode},{" "}
                    {shortDetail.country}
                  </Col>
                  <Col md={1} sm={1} xs={2} style={{ position: "relative" }}>
                    <img
                      className={styles.greentick}
                      src={greentickmark}
                      alt=""
                    />
                  </Col>
                </Row>
              </>
            ) : beneficiaryCardSelection === true ? (
              <VisitedBeneficiary
                showBeneficiaryDetail={showBeneficiaryDetail}
                setShowBeneficiaryDetail={setShowBeneficiaryDetail}
                beneficiaryList={beneficiaryList}
                shortDetail={shortDetail}
                setShortDetail={setShortDetail}
                setStepsToShow={setStepsToShow}
                setBeneficiaryBankCardSelection={
                  setBeneficiaryBankCardSelection
                }
                beneficiaryCardSelection={beneficiaryCardSelection}
                setBeneficiaryCardSelection={setBeneficiaryCardSelection}
              />
            ) : (
              <>
                {stepToShow === "BeneficiaryStep1" ? (
                  <>
                    <div className={styles.showonWeb}>
                      <hr style={{ marginTop: "0px" }} />
                      <Beneficiaryform
                        name={name}
                        handleChange={handleChange}
                        valid={valid}
                        nameError={nameError}
                        handleBlur={handleBlur}
                        countryOptions={countryOptions}
                        country={country}
                        handleChangeOptionforCountry={
                          handleChangeOptionforCountry
                        }
                        email={email}
                        emailError={emailError}
                        phoneNumber={phoneNumber}
                        setPhoneNumber={setPhoneNumber}
                        countryCode={countryCode}
                        phoneNoError={phoneNoError}
                        postalCode={postalCode}
                        postalError={postalError}
                        address={address}
                        city={city}
                        state={state}
                        nextSectionError={nextSectionError}
                        checkIfValid={checkIfValid}
                        loading={loading}
                        indianCountryCode={indianCountryCode}
                        handleCountryCheck={handleCountryCheck}
                        fixedCountry={fixedCountry}
                        themeColor={themeColor}
                        // referenceNumber={referenceNumber}
                      />
                    </div>
                    {screenWidth < 576 && (
                      <>
                        {addnewButton && (
                          <Row>
                            <Col
                              sm={6}
                              xs={6}
                              className={styles.nodatafoundStyling}
                            >
                              No Data Found
                            </Col>
                            <Col sm={6} xs={6}>
                              <Button
                                style={{
                                  margin: "10px 0px",
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: "14px",
                                }}
                                onClick={() => setShowModal(true)}
                              >
                                Add New
                              </Button>
                            </Col>
                          </Row>
                        )}
                        <Modal
                          show={stepToShow === "BeneficiaryStep1" && showModal}
                        >
                          <div style={{ padding: "20px" }}>
                            <Row>
                              <Col
                                md={9}
                                sm={9}
                                xs={9}
                                className={styles.Title}
                              >
                                Personal Detail
                              </Col>
                              <Col
                                md={3}
                                sm={3}
                                xs={3}
                                onClick={
                                  addnewButton
                                    ? () => setShowModal(false)
                                    : handleChangeBack
                                }
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  padding: "10px",
                                }}
                              >
                                <img src={cross} alt="nav-close" />
                              </Col>
                            </Row>
                            <hr style={{ marginTop: "0px" }} />
                            <Beneficiaryform
                              name={name}
                              handleChange={handleChange}
                              valid={valid}
                              nameError={nameError}
                              handleBlur={handleBlur}
                              countryOptions={countryOptions}
                              country={country}
                              handleChangeOptionforCountry={
                                handleChangeOptionforCountry
                              }
                              email={email}
                              emailError={emailError}
                              phoneNumber={phoneNumber}
                              setPhoneNumber={setPhoneNumber}
                              countryCode={countryCode}
                              phoneNoError={phoneNoError}
                              postalCode={postalCode}
                              postalError={postalError}
                              address={address}
                              city={city}
                              state={state}
                              nextSectionError={nextSectionError}
                              checkIfValid={checkIfValid}
                              loading={loading}
                              indianCountryCode={indianCountryCode}
                              handleCountryCheck={handleCountryCheck}
                              fixedCountry={fixedCountry}
                              themeColor={themeColor}
                              // referenceNumber={referenceNumber}
                            />
                          </div>
                        </Modal>
                      </>
                    )}
                  </>
                ) : (
                  ""
                )}
              </>
            )}
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export default AddressDetail;
